import './ArtistCard.css';
export default {
    "card": "ArtistCard_card__1exbk",
    "badge": "ArtistCard_badge__1exbk",
    "avatar": "ArtistCard_avatar__1exbk",
    "contentWrapper": "ArtistCard_contentWrapper__1exbk",
    "textWrapper": "ArtistCard_textWrapper__1exbk",
    "name": "ArtistCard_name__1exbk",
    "tagline": "ArtistCard_tagline__1exbk"
};
